
    const data = {"name":"src/core/icons/arrow-u-right-bottom","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m20 16-5.5 5.5-1.42-1.41L16.17 17H10.5a6.5 6.5 0 1 1 0-13H18v2h-7.5C8 6 6 8 6 10.5S8 15 10.5 15h5.67l-3.08-3.09 1.41-1.41L20 16Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            